<div className='wrapper'>
    <div [class]="className">
    </div>
</div>